<template>
    <client-page>
        <v-sheet class="about-visual white--text image-card" style="background-image:url(/images/sub/about/about-visual-bg.jpg)">
            <v-container>
                <div>
                    <h2 class="font-size-40 font-size-md-52 font-size-lg-72 line-height-13 mb-8 mb-lg-16">
                        <span class="font-weight-regular">마이스펙</span> <br>
                        채용대행 서비스
                    </h2>
                    <p class="page-text--lg mb-8 mb-lg-16">
                        마이스펙의 체계적인 채용프로세스에 운영사인 ㈜디엔아이씨 자체 DB, 커뮤니티, SNS 등을 활용하여 <br class="d-none d-md-block">
                        보다 빠르고 정확한 결과물을 만들어내는 서비스 입니다.
                    </p>
                    <p class="page-text--lg">
                        정규직은 물론 프로젝트 단위 별 과업을 수행해야하는 MICE산업의 특성상 프로젝트 수행직 <br class="d-none d-md-block">
                        (전담인력, 전문프리랜서, 전문인력 등) 채용은 절대적이지만 많은 시간과 비용을 투자해야만 하는 <br class="d-none d-md-block">
                        채용 업무를 마이스펙이 대행함으로써 기업 또는 담당PM은 본 프로젝트에 보다 집중할 수 있습니다.
                    </p>
                </div>
            </v-container>
        </v-sheet>
        <section class="sub-section">
            <v-container>
                <div class="text-center mb-60 mb-md-100 mb-lg-140">
                    <h2 class="font-size-40 font-size-md-52 font-size-lg-72 line-height-13 primary--text mb-8 mb-lg-16">
                        MICEPEC Recruiting Agent
                    </h2>
                    <p class="page-text--lg line-height-13">
                        마이스펙의 채용서비스가 궁금해요!
                    </p>
                </div>
                <div class="tit-wrap text-center justify-center">
                    <h3 class="font-size-28 font-size-md-36 font-size-lg-48 line-height-13">
                        채용서비스의 장점
                    </h3>
                </div>
                <v-row>
                    <v-col v-for="item in advantage" :key="item.title" cols="6" md="3">
                        <v-card elevation="0" rounded="lg" color="grey-f5" class="h-100">
                            <v-layout column align-center class="pa-20 pa-md-30 pa-lg-40 text-center">
                                <v-img :src="item.icon" max-width="80" class="mb-16 mb-lg-40" />
                                <h4 class="tit--sm line-height-1 mb-4 mb-lg-10">{{item.title}}</h4>
                                <p v-html="item.sc" class="font-size-14 font-size-lg-18 line-height-15 grey--text"></p>
                            </v-layout>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </section>
        <section class="sub-section grey-f7">
            <v-container>
                <div class="tit-wrap text-center justify-center">
                    <h3 class="font-size-28 font-size-md-36 font-size-lg-48 line-height-13">
                        채용서비스 영역
                    </h3>
                </div>
                <v-row>
                    <v-col cols="12" md="6" lg="4">
                        <title-card title="Basic Plan" color="primary lighten-3">
                            <div class="circle-item circle-item--outlined grey-c">
                                <p>
                                    인력 섭외 <br class="d-none d-lg-block">
                                    대행 서비스
                                </p>
                            </div>
                            <p class="font-size-14 font-size-lg-18 line-height-15 grey--text mt-6 mt-lg-10">
                                필요인력 리스트 제공
                            </p>
                        </title-card>
                    </v-col>
                    <v-col cols="12" md="6" lg="4" class="mt-10 mt-md-0">
                        <title-card title="Standard Plan" color="primary lighten-1">
                            <v-layout align-center>
                                <div class="circle-item grey-f5">
                                    <p class="grey--text">
                                        Basic Plan
                                    </p>
                                </div>
                                <i class="icon icon-plus2 mx-6 mx-lg-6"></i>
                                <div class="circle-item circle-item--outlined grey-c">
                                    <p>
                                        행정서비스 대행
                                    </p>
                                </div>
                            </v-layout>
                        </title-card>
                    </v-col>
                    <v-col cols="12" lg="4" class="mt-10 mt-lg-0">
                        <title-card title="Premium Plan" color="primary darken-1">
                            <v-layout align-center>
                                <div class="circle-item primary lighten-5">
                                    <p class="primary--text">
                                        Standard Plan
                                    </p>
                                </div>
                                <i class="icon icon-plus2 mx-6 mx-lg-6"></i>
                                <div class="circle-item circle-item--outlined grey-c">
                                    <p>
                                        현장 인력관리 대행
                                    </p>
                                </div>
                            </v-layout>
                        </title-card>
                    </v-col>
                </v-row>
                <!-- <p class="font-size-14 font-size-lg-18 line-height-15 grey--text text-center mt-20 mt-lg-40">* 급여 대납 건은 별도 상담 부탁드립니다.</p> -->
            </v-container>
        </section>
        <section class="sub-section line-height-13 white--text image-card" style="background-image: url(/images/sub/about/about-img.jpg)">
            <v-container>
                <v-layout column align-center class="text-center">
                    <div class="tit-wrap justify-center">
                        <h3 class="font-size-28 font-size-md-36 font-size-lg-48">
                            서비스 문의
                        </h3>
                    </div>
                    <v-img src="/images/sub/about/about-icon2.svg" class="mw-140px mw-lg-180px mb-20 mb-lg-40" />
                    <v-divider class="primary lighten-2 border-2 border-lg-4 w-100 mx-auto mb-12 mb-lg-20" style="max-width: 30px" />
                    <p class="font-size-14 font-size-lg-18 line-height-15 mb-40 mb-lg-80">
                        Tel. 02)325-9123 <br>
                        E-mail. support@micepec.com
                    </p>
                    <h4 class="tit--sm word-keep-all mb-20 mb-lg-40">
                        채용대행 서비스의 시작 마이 스펙과 함께하세요
                    </h4>
                    <v-btn to="/center/inquiry" large color="white" class="grey-13--text">
                        <span class="font-size-lg-20">채용대행 서비스 문의</span>
                    </v-btn>
                </v-layout>                
            </v-container>
        </section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import TitleCard from "@/components/client/about/title-card.vue";

export default {
    components: {
        ClientPage,
        TitleCard,
    },
    data: () => ({
        advantage: [
            {
                title: "DB 플랫폼",
                sc: "자체 DB관리 및 <br class='d-none d-lg-block' />전문구인구직 플랫폼 보유",
                icon: "/images/sub/about/about-icon1-1.svg",
            },
            {
                title: "정확한 매칭",
                sc: "전문 컨설턴트를 통해 <br class='d-none d-lg-block' />직무별 인재 섭외",
                icon: "/images/sub/about/about-icon1-2.svg",
            },
            {
                title: "신속한 채용",
                sc: "20년 이상의 축적된 노하우 <br class='d-none d-lg-block' />신속하고 효율적인 인재 채용",
                icon: "/images/sub/about/about-icon1-3.svg",
            },
            {
                title: "기밀 유지",
                sc: "기업과 지원자의 정보 보호 및 <br class='d-none d-lg-block' />철저한 기밀유지",
                icon: "/images/sub/about/about-icon1-4.svg",
            },
        ],
    }),
    props: {
    },
    mounted() {
    },
    methods: {
    },
};
</script>

<style lang="scss" scoped>
.sub-section{
    padding: 60px 0;
}
.container{
    max-width: calc(var(--container-lg) + 24px);
}
.about-visual{
    height: 400px ;
    .container{
        height: 100%;
        display: flex;
        align-items: center;
        background-image: url(/images/sub/about/about-visual.svg);
        background-position: right center;
        background-repeat: no-repeat;
        background-size: auto 100%;
    }
}
.circle-item{
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-weight: 700;
    font-size: 1.4rem;
    line-height: 1.5;
    width: 130px;
    height: 130px;
    border-radius: 50%;
    padding: 12px;
    word-break: keep-all;
}
.circle-item--outlined{
    font-weight: 400;
    border-width: 2px;
    border-style: solid;
    background-color: transparent !important;
}
@media (min-width:576px){
}
@media (min-width:768px){
    .sub-section{
        padding: 100px 0;
    }
    .about-visual{
        height: 460px ;
    }
}
@media (min-width:1024px){
    .sub-section{
        padding: 140px 0;
    }
    .about-visual{
        height: 600px ;
    }
    .circle-item{
        font-size: 1.8rem;
        width: 150px;
        height: 150px;
    }
    .circle-item--outlined{
        border-width: 4px;
    }
}
@media (min-width:1200px){
    .circle-item{
        width: 170px;
        height: 170px;
    }
}
</style>